export default __webpack_public_path__ + "static/media/hidraulic.11c89a58.png";